/* eslint-disable @next/next/no-css-tags */
/* eslint-disable @next/next/no-img-element */

import { sanityClient, PortableText } from '../../lib/sanity';

import styles from '../../styles/Home.module.scss';

import StandardLayout from '../../components/layouts/StandardLayout';
import IntroCopyBlock from '../../components/elements/IntroCopyBlock';
import Spacer from '../../components/elements/Spacer';

import WhiteBlueIllustration from '../../components/elements/WhiteBlueIllustration';
import MembershipBlock from '../../components/elements/MembershipBlock';
import GreenQuote from '../../components/GreenQuote';

const more2ChildCareQuery = `
{"membershipPageQuery": *[_id=="1f7209d5-8047-4e27-b7fd-51b3ffb7ae82"] {
  title,
  meta,
  introheading,
  introcopy,
  pagequote,
  pinkmessage,
  paragraphs,
  customblocks,
  headerimage,
},
  "companyInfoQuery" : *[_type=="company"] {
    overlaytitle,
    message,
    title,
    footer,
    sociallinks,
    email,
    numbers
  },
  "nurseryQuery" : *[_type=="nurseries"] {
    address,
    linkaddress,
    "manuscriptURL": manuscript.asset->url,
    mapimage
  },
  "membershipQuery" : *[_type=="memberships"] | order(title asc) {
    _id,
    title,
    image,
    benefit,
    website,
    coupon
  }
}
`;

export default function ourPartners({ membershipPageQuery, companyInfoQuery, nurseryQuery, membershipQuery }) {
  const PageInfo = membershipPageQuery[0];
  const Company = companyInfoQuery;
  const Nurseries = nurseryQuery;
  const Memberships = membershipQuery;
  const PageQuote = PageInfo.pagequote;

  return (
    <>
      <StandardLayout CompanyInfo={Company} Nurseries={Nurseries} PageInfo={PageInfo} headerWidth={1920} headerHeight={600} headerMinHeight={300} hideLeadImage={false} hideLink={true}>
        <div className={styles.mainContent}>
          <div className="container">
            <IntroCopyBlock PageInfo={PageInfo} />
            <Spacer mt={3} />
            <MembershipBlock Memberships={Memberships} />
          </div>
        </div>

        {PageQuote && <GreenQuote quote={PageQuote} />}
        <WhiteBlueIllustration />
      </StandardLayout>
    </>
  );
}

export async function getStaticProps() {
  const { membershipPageQuery, companyInfoQuery, nurseryQuery, membershipQuery } = await sanityClient.fetch(more2ChildCareQuery);
  return { props: { membershipPageQuery, companyInfoQuery, nurseryQuery, membershipQuery } };
}
